import type {
  ListActiveDestinationsRequest,
  ListActiveDestinationsResponse,
} from "@/api/app";
import type { LoadedDestinationInfo } from "@/types/global";

import { getPreviewGraph } from "../graph";
import type { PreviewDestination } from "../graph/types";
import { PREVIEW_ENV_ID } from "../runtime";

// DestinationKey is a narrow union of known platform slugs that doesn't
// include our synthetic preview strings, so the cast is unavoidable.
function toLoadedDestinationInfo(d: PreviewDestination): LoadedDestinationInfo {
  return {
    id: d.id,
    name: d.platform as unknown as LoadedDestinationInfo["name"],
    instance_name: d.name,
    custom_label: d.name,
    type_slug: d.platform,
    enabled: d.isEnabled,
    env_id: PREVIEW_ENV_ID,
    is_valid: true,
    is_valid_client_side: true,
    is_valid_server_side: true,
    fivetran_group_id: null,
    has_baa: false,
    connection_mode: "server",
    connected_audiences_count: 0,
    destinationCategories: [],
    settings: {},
  };
}

export function handleListActiveDestinations(
  _params: ListActiveDestinationsRequest,
): ListActiveDestinationsResponse {
  const graph = getPreviewGraph();
  return {
    destinations: graph.destinations.map(toLoadedDestinationInfo),
  };
}
